import { Colors } from '../../consts/Colors.js';
import FONTS from '../../consts/Fonts.js';
import { tags } from '../../consts/Tags.js';
import ButtonRounded from '../../prefabs/global/buttons/ButtonRounded.js';
import PopUpBlue from '../../prefabs/global/popup/PopUpBlue.js';
import SoundManager from '../../prefabs/SoundManager.js';
import AbstractScene from '../AbstractScene.js';

export default class DebutChapitre2 extends AbstractScene {

    constructor() {
        super({
            key: "DebutChapitre2"
        })
    }

    preload() {
        this._preload();

        
    }

    init(data){
        this._init(data);   

        this.soundManager = new SoundManager();
        this.soundManager.stopAllLoops()
        this.soundManager.playAudio('CafeDeManha');
    }

    create() {
        // Ajout fond
        let background = this.add.image(0, 0, 'Chapitre2_transition_background').setOrigin(0);

        // Ajout num chapitre
        let numChapitre = this.add.text(1058, 420, 'CHAPITRE 2',{
            fontSize: '18px',
            fontFamily: FONTS.Inter18Light,
            color: "#C85246",
            letterSpacing:5
        }).setOrigin(0)
        numChapitre.setAlpha(0)

        // Ajout titre
        let titre1 = this.add.image(610, 140, 'Chapitre2_transition_titre').setOrigin(0)
        titre1.setAlpha(0)

        // Ajout pop up

        // Ajout transitions

        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        this.tweens.add({
            targets: rect,
            alpha: 0,
            duration: 1000,
            onComplete: () => {
                rect.destroy();
                
            }
        })

        this.tweens.add({
            targets: numChapitre,
            alpha: 1,
            delay: 200,
            duration: 200,
        })

        titre1.x -=50
        this.tweens.add({
            targets: titre1,
            alpha: 1,
            x: titre1.x + 50,
            delay: 400,
            duration: 400,
        })

        this.time.addEvent({
            delay: 1000,
            callback: () => {
                this.addPopUp()
            }
        })

    }

    addPopUp(){

        this.popupAide = new PopUpBlue(this, this.width/2, 808, 653, 367)
        this.popupAide.depth = 1001

        const txt ="Une fois à Rio, je pars sans perdre de temps à la recherche du Dr Oscar Oliviera. Il pourra m’aider à comprendre pourquoi Leïla Cercis travaillait sur la fleur de verre.\n<class=\"Inter28BoldItalic\">Je me dirige donc vers son lieu de travail : le jardin botanique de Rio.</class>"
        let textElmt = this.add.rexTagText(0, 0, txt, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '24px',
            color: Colors.Text.White,
            align: 'left',
            wordWrap: { width: 536 },
            lineSpacing: 8,
            tags: tags
        }).setOrigin(0.5, 0)

        this.popupAide.addElementToBody(textElmt, 40)

        let button = new ButtonRounded(this, 0, 0, {
            text: "Démarrer le chapitre 2",
            color: Colors.Elmt.White,
            borderColor: Colors.Elmt.White,
            borderHoverColor: Colors.Elmt.Blue,
            textColor: Colors.Text.Black,
            textHoverColor: Colors.Text.Blue
        })
        this.popupAide.addButtonToBody(button)
        button.setClickFunction( () => {
            this.animOut()
        })

        this.popupAide.animIn()
    }

    animOut(){
        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        rect.setAlpha(0)
        rect.depth = 1002
        this.tweens.add({
            targets: rect,
            alpha: 1,
            duration: 1000,
            onComplete: () => {
                this.scene.start("Chapitre2")
            }
        })
    }
}